module.exports = __webpack_public_path__ + "img/commodity3.9a9e69f2.png";